import { Link } from "react-router-dom";
import { ArrowLeft, AlertTriangle } from "lucide-react";

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-red-600 transition-colors">
            <ArrowLeft className="w-5 h-5" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-amber-600" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900">Disclaimer</h1>
          </div>

          <div className="prose prose-slate max-w-none">
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-8">
              <p className="text-amber-800 font-medium mb-0">
                CanadaTestPrep is an independent educational resource.
              </p>
            </div>

            <ul className="space-y-4 text-slate-600">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>We are <strong>not affiliated</strong> with Immigration, Refugees and Citizenship Canada (IRCC) or the Government of Canada.</span>
              </li>
              
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>All study materials are based on publicly available sources, including the Discover Canada guide.</span>
              </li>
              
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>Our practice questions are designed to reflect the format and subject matter of the Canadian citizenship test but are <strong>not official test questions</strong>.</span>
              </li>
              
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>Any references to rankings, ratings, popularity, or comparative statements are promotional language and do not represent official endorsements or certified rankings.</span>
              </li>
              
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>User testimonials reflect individual experiences and may vary.</span>
              </li>
              
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>The Pass Guarantee applies only to eligible Lifetime Access users who meet all completion requirements as outlined in the <Link to="/terms" className="text-red-600 hover:underline">Terms of Service</Link>.</span>
              </li>
              
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                <span>The Service is intended as a <strong>study aid</strong> and does not replace official government materials.</span>
              </li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <h2 className="text-xl font-bold text-slate-900 mb-4">Questions?</h2>
              <p className="text-slate-600">
                For questions regarding this Disclaimer, please contact us through our{" "}
                <Link to="/contact" className="text-red-600 hover:underline">contact form</Link>.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-8">
        <div className="max-w-4xl mx-auto px-4 text-center text-sm">
          <p>© 2026 CanadaTestPrep.ca. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Disclaimer;
